import { isBrowser } from '../../utils/fragments/isBrowser';

export const editorJsLinkToolClass = isBrowser
  ? require('../../../vendor/editorjs-link/bundle')
  : undefined;

export function loadLinkToolCss() {
  // Empty method, but calling it ensures the dependency is imported, which adds the CSS to the web page. This is required to render the link preview in messages before editorjs was loaded.
}
